import React, { useContext, useEffect, useState } from 'react';
import { useFetchQuery } from 'quanta-flows';
// import useFetchQuery from '../../../../../lib/graphql/useFetchQuery';
import { GET_BUY_MOTOR_POLICY_VAR_DETAILS } from '../queries';
import {
  DataGridGroup,
  useResponsiveParams,
  Text,
  Modal,
  Grid,
  GridItem,
  Label,
} from 'quanta-ui';
// import Parse from '../../../../../lib/intl/CurrencyFormater';
import { CurrencyFormater } from 'quanta-flows';
import { QuantaConfigContext } from 'quanta-flows';
// import { ConfigContext } from '../../../../../lib/config/ConfigProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
// import { Error, Loading } from '../../../../../lib/layout';
import { Error,Loading } from 'quanta-flows/modules/layout';
export default function CoversDataModal({
  setShowCoversModal,
  showCoversModal,
  lobCode,
  lobName,
  productCode,
  productName,
  productType,
}) {
  const fetchQuery = useFetchQuery();
  const [coverData, setCoverData] = useState({
    addOnCovers: {},
    rawRiskData: [],
  });
  const [idv, setIdv] = useState('');
  const [tenure, setTenure] = useState('');
  const [annualPremium, setAnnualPremium] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const repeatForDesktop = 3,
    repeatForMobile = 2,
    repeatForIpad = 3;

  const repeat = useResponsiveParams({
    for_desktop: repeatForDesktop,
    for_mobile: repeatForMobile,
    for_iPad: repeatForIpad,
  });

  const modalSize = useResponsiveParams({
    for_desktop: 'large',
    for_mobile: 'full',
    for_iPad: 'full',
  });

  const { branding } = useContext(QuantaConfigContext);

  useEffect(() => {
    const getAddOnCoversData = async () => {
      try {
        const getMotorPolicyInfo = fetchQuery({
          query: GET_BUY_MOTOR_POLICY_VAR_DETAILS,
        });
        setLoading(true);
        const { data } = await getMotorPolicyInfo;
        setLoading(false);
        setCoverData({
          ...data?.buyMotorPolicy?.coverData,
        });
        setIdv(
          data?.buyMotorPolicy?.vehicleTabDetails
            ?.insuredDeclaredDetails?.vehicleIDV ||
            data?.buyMotorPolicy?.quoteData?.changedIDV,
        );
        setTenure(
          data?.buyMotorPolicy?.quoteData?.premiumData?.tenure ||
            data?.buyMotorPolicy?.quoteData?.tenure ||
            data?.buyMotorPolicy?.premiumData?.tenure,
        );
        setAnnualPremium(
          //SA975
          data?.buyMotorPolicy?.premiumData?.totalPremium ||
            data?.buyMotorPolicy?.quoteData?.premiumData?.totalPremium ||
            data?.buyMotorPolicy?.premiumData?.finalpremium ||
            data?.buyMotorPolicy?.quoteData?.premiumData?.finalpremium,
            //EA975
        );
      } catch (error) {
        setLoading(false);
        setError(error?.message);
      }
    };
    if (showCoversModal) {
      getAddOnCoversData();
    }
  }, [showCoversModal]);

  const otherProps = {
    flow: 'cols',
    repeat,
    gapX: 6,
    gapY: 0,
    spaceY: 2,
    size: 'full',
    titleSeverity: 'info',
    textType: 'normal',
    nullData: () => <Text severity="neutral">Not Captured</Text>,
  };

  const sortedCovers = Object.keys(coverData?.addOnCovers)
    ?.filter(
      (addOnCover) =>
        coverData?.addOnCovers[`${addOnCover}`]?.selected,
    )
    ?.sort(function (a, b) {
      return (
        Object.keys(coverData?.addOnCovers[`${a}`]?.attributes)
          ?.length -
        Object.keys(coverData?.addOnCovers[`${b}`]?.attributes)
          ?.length
      );
    });

  const addOnCoverDetailsData = [
    {
      grid_type: 'data',
      grid_data: [
        {
          label: 'IDV',
          text: idv ? `${CurrencyFormater(idv, true, false, branding)}` : '',
        },
        {
          label: 'Tenure',
          text: tenure
            ? `${tenure} year${parseFloat(tenure) > 1 ? 's' : ''}`
            : '',
        },
        {
          label: 'Annual Premium (inclusive of all taxes)',
          colSpan: repeat === repeatForDesktop ? 1 : repeat,
          text: (
            <Text>
              {annualPremium ? (
                <Text
                  severity={'info'}
                  type={'larger'}
                  className={'pt-1'}
                >
                  {CurrencyFormater(annualPremium, true, false, branding)}
                </Text>
              ) : (
                <Text severity={'neutral'}>Not Captured</Text>
              )}
            </Text>
          ),
        },
      ],
    },
    {
      grid_type: 'data',
      title: (
        <Text
          severity={'info'}
          className={'font-semibold'}
          type={'large'}
        >
          Add On Covers
        </Text>
      ),
      grid_data:
        Object.keys(coverData?.addOnCovers)?.filter(
          (addOnCover) =>
            coverData?.addOnCovers[`${addOnCover}`]?.selected,
        )?.length > 0
          ? sortedCovers?.map((addOnCover, idx) => {
              return {
                label: (
                  <Text type={'normal'} className={'flex space-x-2'}>
                    <Text severity={'success'}>
                      <FontAwesomeIcon icon={faCheck} />
                    </Text>
                    <Text severity={'dark'}>{addOnCover === 'CNG Kit TP' ? 'External CNG/LPG kit' : addOnCover}</Text>
                  </Text>
                ),
                colSpan: repeat,
                //colSpan: (Object.keys(coverData?.addOnCovers[`${addOnCover}`]?.attributes)?.length === 0)?(repeat === repeatForDesktop ? 1: repeat):Object.keys(coverData?.addOnCovers[`${addOnCover}`]?.attributes)?.length === 1 ? (repeat === repeatForDesktop ? 1: repeat): Object.keys(coverData?.addOnCovers[`${addOnCover}`]?.attributes)?.length === 2 ? 2 :repeat,
                text: (
                  <Grid
                    key={idx}
                    repeat={repeat}
                    flow={'cols'}
                    gap={2}
                    className={'my-2'}
                  >
                    {coverData?.addOnCovers[`${addOnCover}`]
                      ?.attributes &&
                      Object.keys(
                        coverData?.addOnCovers[`${addOnCover}`]
                          ?.attributes,
                      )
                        ?.filter(
                          (attribute) =>
                            coverData?.rawRiskData
                              ?.find(
                                (risk) =>
                                  risk?.covers?.find(
                                    (cover) =>
                                      cover?.name?.toLowerCase() ===
                                      addOnCover?.toLowerCase(),
                                  ) !== undefined,
                              )
                              ?.covers?.find(
                                (cover) =>
                                  cover?.name?.toLowerCase() ===
                                  addOnCover?.toLowerCase(),
                              )
                              ?.attributes?.find(
                                (attr) => attr?.name === attribute,
                              )?.showOnScreen,
                        )
                        ?.map((attribute, idx) => {
                          return (
                            <GridItem
                              key={idx}
                              colSpan={
                                Object.keys(
                                  coverData?.addOnCovers[
                                    `${addOnCover}`
                                  ]?.attributes,
                                )?.length === 1
                                  ? repeat
                                  : 1
                              }
                              className={'ml-6'}
                            >
                              <Label
                                text={`${
                                  coverData?.rawRiskData
                                    ?.find(
                                      (risk) =>
                                        risk?.covers?.find(
                                          (cover) =>
                                            cover?.name?.toLowerCase() ===
                                            addOnCover?.toLowerCase(),
                                        ) !== undefined,
                                    )
                                    ?.covers?.find(
                                      (cover) =>
                                        cover?.name?.toLowerCase() ===
                                        addOnCover?.toLowerCase(),
                                    )
                                    ?.attributes?.find(
                                      (attr) =>
                                        attr?.name === attribute,
                                    )?.displayName
                                }`}
                                severity={'info'}
                              >
                                {coverData?.rawRiskData
                                  ?.find(
                                    (risk) =>
                                      risk?.covers?.find(
                                        (cover) =>
                                          cover?.name?.toLowerCase() ===
                                          addOnCover?.toLowerCase(),
                                      ) !== undefined,
                                  )
                                  ?.covers?.find(
                                    (cover) =>
                                      cover?.name?.toLowerCase() ===
                                      addOnCover?.toLowerCase(),
                                  )
                                  ?.attributes?.find(
                                    (attr) =>
                                      attr?.name === attribute,
                                  )?.fieldDataType === 'amount' ? (
                                  coverData?.addOnCovers[
                                    `${addOnCover}`
                                  ]?.attributes[`${attribute}`] !==
                                    null &&
                                  coverData?.addOnCovers[
                                    `${addOnCover}`
                                  ]?.attributes[`${attribute}`] !==
                                    undefined &&
                                  !isNaN(
                                    parseFloat(
                                      coverData?.addOnCovers[
                                        `${addOnCover}`
                                      ]?.attributes[`${attribute}`],
                                    ),
                                  ) ? (
                                    CurrencyFormater(
                                      `${
                                        coverData?.rawRiskData
                                          ?.find(
                                            (risk) =>
                                              risk?.covers?.find(
                                                (cover) =>
                                                  cover?.name?.toLowerCase() ===
                                                  addOnCover?.toLowerCase(),
                                              ) !== undefined,
                                          )
                                          ?.covers?.find(
                                            (cover) =>
                                              cover?.name?.toLowerCase() ===
                                              addOnCover?.toLowerCase(),
                                          )
                                          ?.attributes?.find(
                                            (attr) =>
                                              attr?.name ===
                                              attribute,
                                          )
                                          ?.dataValues?.find(
                                            (codeVal) =>
                                              codeVal?.code
                                                ?.toString()
                                                ?.toLowerCase() ===
                                              coverData?.addOnCovers[
                                                `${addOnCover}`
                                              ]?.attributes[
                                                `${attribute}`
                                              ]
                                                ?.toString()
                                                ?.toLowerCase(),
                                          )
                                          ? coverData?.rawRiskData
                                              ?.find(
                                                (risk) =>
                                                  risk?.covers?.find(
                                                    (cover) =>
                                                      cover?.name?.toLowerCase() ===
                                                      addOnCover?.toLowerCase(),
                                                  ) !== undefined,
                                              )
                                              ?.covers?.find(
                                                (cover) =>
                                                  cover?.name?.toLowerCase() ===
                                                  addOnCover?.toLowerCase(),
                                              )
                                              ?.attributes?.find(
                                                (attr) =>
                                                  attr?.name ===
                                                  attribute,
                                              )
                                              ?.dataValues?.find(
                                                (codeVal) =>
                                                  codeVal?.code
                                                    ?.toString()
                                                    ?.toLowerCase() ===
                                                  coverData?.addOnCovers[
                                                    `${addOnCover}`
                                                  ]?.attributes[
                                                    `${attribute}`
                                                  ]
                                                    ?.toString()
                                                    ?.toLowerCase(),
                                              )?.value
                                          : coverData?.addOnCovers[
                                              `${addOnCover}`
                                            ]?.attributes[
                                              `${attribute}`
                                            ]
                                      }`,
                                      true,
                                      false,
                                      branding,
                                    )
                                  ) : (
                                    <Text severity={'neutral'}>
                                      Not Captured
                                    </Text>
                                  )
                                ) : coverData?.addOnCovers[
                                    `${addOnCover}`
                                  ]?.attributes[`${attribute}`] ? coverData?.rawRiskData
                                  ?.find(
                                    (risk) =>
                                      risk?.covers?.find(
                                        (cover) =>
                                          cover?.name?.toLowerCase() ===
                                          addOnCover?.toLowerCase(),
                                      ) !== undefined,
                                  )
                                  ?.covers?.find(
                                    (cover) =>
                                      cover?.name?.toLowerCase() ===
                                      addOnCover?.toLowerCase(),
                                  )
                                  ?.attributes?.find(
                                    (attr) =>
                                      attr?.name ===
                                      attribute,
                                  )
                                  ?.dataValues?.find(
                                    (codeVal) =>
                                      codeVal?.code
                                        ?.toString()
                                        ?.toLowerCase() ===
                                      coverData?.addOnCovers[
                                        `${addOnCover}`
                                      ]?.attributes[
                                        `${attribute}`
                                      ]
                                        ?.toString()
                                        ?.toLowerCase(),
                                  ) ? coverData?.rawRiskData
                                  ?.find(
                                    (risk) =>
                                      risk?.covers?.find(
                                        (cover) =>
                                          cover?.name?.toLowerCase() ===
                                          addOnCover?.toLowerCase(),
                                      ) !== undefined,
                                  )
                                  ?.covers?.find(
                                    (cover) =>
                                      cover?.name?.toLowerCase() ===
                                      addOnCover?.toLowerCase(),
                                  )
                                  ?.attributes?.find(
                                    (attr) =>
                                      attr?.name ===
                                      attribute,
                                  )
                                  ?.dataValues?.find(
                                    (codeVal) =>
                                      codeVal?.code
                                        ?.toString()
                                        ?.toLowerCase() ===
                                      coverData?.addOnCovers[
                                        `${addOnCover}`
                                      ]?.attributes[
                                        `${attribute}`
                                      ]
                                        ?.toString()
                                        ?.toLowerCase(),
                                  )?.value: ( 
                                  coverData?.addOnCovers[
                                    `${addOnCover}`
                                  ]?.attributes[`${attribute}`]
                                ) : (
                                  <Text severity={'neutral'}>
                                    Not Captured
                                  </Text>
                                )}
                              </Label>
                            </GridItem>
                          );
                        })}
                  </Grid>
                ),
              };
            })
          : [
              {
                text: (
                  <Text
                    severity={'neutral'}
                    type={'larger'}
                    className={
                      'text-center flex justify-center items-center'
                    }
                  >
                    No Add On Covers selected for this quote
                  </Text>
                ),
                colSpan: repeat,
              },
            ],
    },
  ];
  return (
    <Modal
      display={showCoversModal}
      severity={'info'}
      title={
        <Text severity={'info'} type={'title'}>
          Your Cover Details
        </Text>
      }
      size={modalSize}
      className={'h-screen flex flex-col justify-start'}
      onClose={(_) => setShowCoversModal(false)}
    >
      {loading && (
        <Loading customMessage={'Fetching Add On Covers'} />
      )}
      {error && <Error error={error} />}
      {!loading && !error && (
        <DataGridGroup
          {...{ data: addOnCoverDetailsData, ...otherProps }}
        />
      )}
    </Modal>
  );
}
